import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=2fcd2ca3&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fcd2ca3"]])

export default __exports__